import type { Team } from "@/types";

interface TeamLogoProps {
  team: Team;
  size?: "sm" | "md" | "lg";
}

const sizeMap = {
  sm: "w-8 h-8 text-[11px]",
  md: "w-12 h-12 text-sm",
  lg: "w-16 h-16 text-lg",
};

export default function TeamLogo({ team, size = "md" }: TeamLogoProps) {
  return (
    <div
      className={`${sizeMap[size]} shrink-0 rounded-full flex items-center justify-center font-heading font-bold tracking-wide ring-2 ring-background-100`}
      style={{
        background: `linear-gradient(135deg, ${team.primaryColor} 0%, ${team.primaryColor} 62%, ${team.secondaryColor} 62%, ${team.secondaryColor} 100%)`,
        color: "#ffffff",
        textShadow: "0 1px 2px rgba(0,0,0,0.45)",
      }}
    >
      {team.abbreviation}
    </div>
  );
}